module.exports = __webpack_public_path__ + "img/square-rounded.b4d4911a.svg";